import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { SiteActions, SiteSelectors } from '@next/core-lib/site';
import { Store, select } from '@ngrx/store';
import { Observable, startWith } from 'rxjs';
import { ManureOfferModel } from 'src/app/offer/models/manure-offer.model';
import { selectLastSuccessfulManureOfferPost } from 'src/app/store/selectors';

import { SiteState } from '../../shared/models';

@Component({
  selector: 'app-offer-confirmation-screen',
  templateUrl: './offer-confirmation-screen.component.html',
  styleUrls: ['./offer-confirmation-screen.component.scss'],
  standalone: false,
})
export class OfferConfirmationScreenComponent implements OnInit {
  private readonly store = inject<Store<SiteState>>(Store);
  private readonly router = inject(Router);

  lastSuccessfulManureOfferPost$: Observable<ManureOfferModel>;

  pageTitle$ = this.store.pipe(select(SiteSelectors.selectPageTitle));

  constructor() {
    this.lastSuccessfulManureOfferPost$ = this.store
      .select(selectLastSuccessfulManureOfferPost)
      .pipe(startWith(undefined));
  }

  ngOnInit(): void {
    this.store.dispatch(SiteActions.updatePageTitle({ pageTitle: 'dashboard.page-title' }));
  }

  redirectToNewOffer(): void {
    this.router.navigate(['/offer']);
  }

  redirectToOfferOverview(): void {
    this.router.navigate(['']);
  }
}
